import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=e58f93ec&scoped=true"
import script from "./Color.vue?vue&type=script&lang=js"
export * from "./Color.vue?vue&type=script&lang=js"
import style0 from "./Color.vue?vue&type=style&index=0&id=e58f93ec&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58f93ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e58f93ec')) {
      api.createRecord('e58f93ec', component.options)
    } else {
      api.reload('e58f93ec', component.options)
    }
    module.hot.accept("./Color.vue?vue&type=template&id=e58f93ec&scoped=true", function () {
      api.rerender('e58f93ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/button/Color.vue"
export default component.exports